import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui';
import { CheckCircle } from 'lucide-react';

export function GameSettledPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-md mx-auto py-6 px-4 space-y-6 min-h-screen bg-[#f5f7f8]">
      {/* Hero Header */}
      <div className="bg-[#e8f5f0] border border-[#006855]/10 rounded-2xl p-5 mb-4">
        <div className="text-[10px] font-black uppercase tracking-[2px] text-[#006855]/70 mb-1">
          Game
        </div>
        <h1 className="text-[22px] font-extrabold text-[#2c2f30] leading-tight">
          Game Settled
        </h1>
      </div>

      {/* Content Card */}
      <Card variant="default">
        <div className="flex flex-col items-center text-center py-8 px-4">
          <div className="w-16 h-16 rounded-full bg-[#e8f5f0] flex items-center justify-center mb-5">
            <CheckCircle className="w-8 h-8 text-[#006855]" />
          </div>
          <h2 className="text-lg font-extrabold text-[#2c2f30] mb-2">
            All Done!
          </h2>
          <p className="text-sm text-[#595c5d] mb-8 max-w-[260px] leading-relaxed">
            The last game has been settled. View all past games in the Library.
          </p>
          <button
            onClick={() => navigate('/library')}
            className="w-full bg-[#006855] text-white border border-[#006855] rounded-2xl py-4 px-6 text-xs font-extrabold uppercase tracking-[0.2em] cursor-pointer hover:bg-[#005b4a] transition-colors active:scale-95"
          >
            View Game Library
          </button>
        </div>
      </Card>
    </div>
  );
}
